// extracted by mini-css-extract-plugin
export default {"pageTitle":"CPTypesPage_pageTitle__f8Apt","staticPageWrapper":"CPTypesPage_staticPageWrapper__7T8a3"};